<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
import { hasAccess } from '@/common/utils'
import { shiQuanConfig } from '@/common/app.config.js'

export default {
    props: {
        openId: String,
        data: {
            type: Object,
            default: () => {}
        },
        name: String
    },
    data() {
        return {
            showPullNewDialog: false,
            modify: hasAccess('200711'),
            list: [],
            shiQuanConfig,
        };
    },
    methods: {
        init() {
            this.friendBehaviorlist()
        },
        async friendBehaviorlist(isExport = 0) {
            let data = await this.api.friendBehaviorlist({
                access_token: localStorage.getItem("access_token"),
                page: 1,
                limit: 5000,
                openId: this.openId,
                isExport
            })
            this.list = data.data
        }
    },
    created() {
        this.init();
    }
};
</script>
